module.exports = (zipNumber) ->

  if '99501' <= zipNumber <= '99950' then name: 'Alaska', code: 'AK'
  else if '35004' <= zipNumber <= '36925' then name: 'Alabama', code: 'AL'
  else if '71601' <= zipNumber <= '72959' then name: 'Arkansas', code: 'AR'
  else if '75502' <= zipNumber <= '75502' then name: 'Arkansas', code: 'AR'
  else if '85001' <= zipNumber <= '86556' then name: 'Arizona', code: 'AZ'
  else if '90001' <= zipNumber <= '96162' then name: 'California', code: 'CA'
  else if '80001' <= zipNumber <= '81658' then name: 'Colorado', code: 'CO'
  else if '06001' <= zipNumber <= '06389' then name: 'Connecticut', code: 'CT'
  else if '06401' <= zipNumber <= '06928' then name: 'Connecticut', code: 'CT'
  else if '20001' <= zipNumber <= '20039' then name: 'District Of Columbia', code: 'DC'
  else if '20042' <= zipNumber <= '20599' then name: 'District Of Columbia', code: 'DC'
  else if '20799' <= zipNumber <= '20799' then name: 'District Of Columbia', code: 'DC'
  else if '19701' <= zipNumber <= '19980' then name: 'Delaware', code: 'DE'
  else if '32004' <= zipNumber <= '34997' then name: 'Florida', code: 'FL'
  else if '30001' <= zipNumber <= '31999' then name: 'Georgia', code: 'GA'
  else if '39901' <= zipNumber <= '39901' then name: 'Georgia', code: 'GA'
  else if '96701' <= zipNumber <= '96898' then name: 'Hawaii', code: 'HI'
  else if '50001' <= zipNumber <= '52809' then name: 'Iowa', code: 'IA'
  else if '68119' <= zipNumber <= '68120' then name: 'Iowa', code: 'IA'
  else if '83201' <= zipNumber <= '83876' then name: 'Idaho', code: 'ID'
  else if '60001' <= zipNumber <= '62999' then name: 'Illinois', code: 'IL'
  else if '46001' <= zipNumber <= '47997' then name: 'Indiana', code: 'IN'
  else if '66002' <= zipNumber <= '67954' then name: 'Kansas', code: 'KS'
  else if '40003' <= zipNumber <= '42788' then name: 'Kentucky', code: 'KY'
  else if '70001' <= zipNumber <= '71232' then name: 'Louisiana', code: 'LA'
  else if '71234' <= zipNumber <= '71497' then name: 'Louisiana', code: 'LA'
  else if '01001' <= zipNumber <= '02791' then name: 'Massachusetts', code: 'MA'
  else if '05501' <= zipNumber <= '05544' then name: 'Massachusetts', code: 'MA'
  else if '20331' <= zipNumber <= '20331' then name: 'Maryland', code: 'MD'
  else if '20335' <= zipNumber <= '20797' then name: 'Maryland', code: 'MD'
  else if '20812' <= zipNumber <= '21930' then name: 'Maryland', code: 'MD'
  else if '03901' <= zipNumber <= '04992' then name: 'Maine', code: 'ME'
  else if '48001' <= zipNumber <= '49971' then name: 'Michigan', code: 'MI'
  else if '55001' <= zipNumber <= '56763' then name: 'Minnesota', code: 'MN'
  else if '63001' <= zipNumber <= '65899' then name: 'Missouri', code: 'MO'
  else if '38601' <= zipNumber <= '39776' then name: 'Mississippi', code: 'MS'
  else if '71233' <= zipNumber <= '71233' then name: 'Mississippi', code: 'MS'
  else if '59001' <= zipNumber <= '59937' then name: 'Montana', code: 'MT'
  else if '27006' <= zipNumber <= '28909' then name: 'North Carolina', code: 'NC'
  else if '58001' <= zipNumber <= '58856' then name: 'North Dakota', code: 'ND'
  else if '68001' <= zipNumber <= '68118' then name: 'Nebraska', code: 'NE'
  else if '68122' <= zipNumber <= '69367' then name: 'Nebraska', code: 'NE'
  else if '03031' <= zipNumber <= '03897' then name: 'New Hampshire', code: 'NH'
  else if '07001' <= zipNumber <= '08989' then name: 'New Jersey', code: 'NJ'
  else if '87001' <= zipNumber <= '88441' then name: 'New Mexico', code: 'NM'
  else if '88901' <= zipNumber <= '89883' then name: 'Nevada', code: 'NV'
  else if '06390' <= zipNumber <= '06390' then name: 'New York', code: 'NY'
  else if '10001' <= zipNumber <= '14975' then name: 'New York', code: 'NY'
  else if '43001' <= zipNumber <= '45999' then name: 'Ohio', code: 'OH'
  else if '73001' <= zipNumber <= '73199' then name: 'Oklahoma', code: 'OK'
  else if '73401' <= zipNumber <= '74966' then name: 'Oklahoma', code: 'OK'
  else if '97001' <= zipNumber <= '97920' then name: 'Oregon', code: 'OR'
  else if '15001' <= zipNumber <= '19640' then name: 'Pennsylvania', code: 'PA'
  else if '02801' <= zipNumber <= '02940' then name: 'Rhode Island', code: 'RI'
  else if '29001' <= zipNumber <= '29948' then name: 'South Carolina', code: 'SC'
  else if '57001' <= zipNumber <= '57799' then name: 'South Dakota', code: 'SD'
  else if '37010' <= zipNumber <= '38589' then name: 'Tennessee', code: 'TN'
  else if '73301' <= zipNumber <= '73301' then name: 'Texas', code: 'TX'
  else if '75001' <= zipNumber <= '75501' then name: 'Texas', code: 'TX'
  else if '75503' <= zipNumber <= '79999' then name: 'Texas', code: 'TX'
  else if '88510' <= zipNumber <= '88589' then name: 'Texas', code: 'TX'
  else if '84001' <= zipNumber <= '84784' then name: 'Utah', code: 'UT'
  else if '20040' <= zipNumber <= '20041' then name: 'Virginia', code: 'VA'
  else if '20040' <= zipNumber <= '20167' then name: 'Virginia', code: 'VA'
  else if '20042' <= zipNumber <= '20042' then name: 'Virginia', code: 'VA'
  else if '22001' <= zipNumber <= '24658' then name: 'Virginia', code: 'VA'
  else if '05001' <= zipNumber <= '05495' then name: 'Vermont', code: 'VT'
  else if '05601' <= zipNumber <= '05907' then name: 'Vermont', code: 'VT'
  else if '98001' <= zipNumber <= '99403' then name: 'Washington', code: 'WA'
  else if '53001' <= zipNumber <= '54990' then name: 'Wisconsin', code: 'WI'
  else if '24701' <= zipNumber <= '26886' then name: 'West Virginia', code: 'WV'
  else if '82001' <= zipNumber <= '83128' then name: 'Wyoming', code: 'WY'
  else 'unknown'



// WEBPACK FOOTER //
// ./app/scripts/views/billing/form-sections/internal/zip-code-to-state.coffee